import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "delivery-notice notice warn"
}
const _hoisted_2 = {
  key: 0,
  class: "item-dimensions",
  style: {"display":"flex"}
}
const _hoisted_3 = {
  key: 2,
  class: "wide-title"
}
const _hoisted_4 = { class: "highlight" }
const _hoisted_5 = { class: "item-meta" }
const _hoisted_6 = { class: "item-supplier-meta" }
const _hoisted_7 = { class: "description" }
const _hoisted_8 = { class: "description--overflow-wrapper" }
const _hoisted_9 = {
  key: 0,
  class: "data-table item-price-list--container"
}
const _hoisted_10 = { class: "item-price-list--item" }
const _hoisted_11 = { class: "item-price-list--item-label" }
const _hoisted_12 = { class: "item-price-list--item-quantity" }
const _hoisted_13 = { class: "item-price-list--item-value" }
const _hoisted_14 = {
  key: 1,
  class: "item-price-list--placeholder placeholder"
}
const _hoisted_15 = {
  key: 0,
  class: "row"
}
const _hoisted_16 = { class: "col col-shrink" }
const _hoisted_17 = {
  key: 1,
  class: "row"
}
const _hoisted_18 = { class: "col" }
const _hoisted_19 = { class: "col col-shrink" }
const _hoisted_20 = { class: "pagination-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_add_icon = _resolveComponent("add-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_close_icon = _resolveComponent("close-icon")!
  const _component_tick_icon = _resolveComponent("tick-icon")!
  const _component_no_data_img = _resolveComponent("no-data-img")!
  const _component_simple_link = _resolveComponent("simple-link")!
  const _component_form_input = _resolveComponent("form-input")!
  const _component_ozn_button = _resolveComponent("ozn-button")!
  const _component_tab_nav = _resolveComponent("tab-nav")!
  const _component_supplier_catalogue_stock_item_card = _resolveComponent("supplier-catalogue-stock-item-card")!
  const _component_q_pagination = _resolveComponent("q-pagination")!
  const _component_filterable_list = _resolveComponent("filterable-list")!
  const _component_entry_search = _resolveComponent("entry-search")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_filterable_list, {
      editing: _ctx.editing,
      expanded: _ctx.expanded,
      height: _ctx.height,
      onAdd: _ctx.openSearch,
      onEdit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editing = true)),
      onCancel: _ctx.cancelEditing,
      onSave: _ctx.handleSave,
      "filter-values": _ctx.filterValues,
      "search-value": _ctx.productQuery,
      "filter-value": _ctx.filterValue,
      "onUpdate:searchValue": _ctx.setQuery,
      "onUpdate:filterValue": _ctx.setFilter
    }, {
      actions: _withCtx(({ emitEvent }) => [
        _createVNode(_component_q_btn, {
          unelevated: "",
          rounded: "",
          onClick: ($event: any) => (emitEvent('add')),
          outline: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_add_icon, { left: "" }),
            _cache[6] || (_cache[6] = _createElementVNode("span", null, "Stock item", -1))
          ]),
          _: 2
        }, 1032, ["onClick"]),
        (_ctx.editing)
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 0,
              class: "q-mr-md q-ml-md",
              unelevated: "",
              rounded: "",
              onClick: ($event: any) => (emitEvent('cancel'))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_close_icon, { left: "" }),
                _cache[7] || (_cache[7] = _createElementVNode("span", null, "Cancel", -1))
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.editing)
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 1,
              unelevated: "",
              rounded: "",
              onClick: ($event: any) => (emitEvent('save')),
              color: "primary"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_tick_icon, { left: "" }),
                _cache[8] || (_cache[8] = _createElementVNode("span", null, "Save", -1))
              ]),
              _: 2
            }, 1032, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      "filterable-list": _withCtx(() => [
        (!_ctx.paginatedStockItems?.length && _ctx.pageSize)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "empty-placeholder cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitEvent('add')))
            }, [
              _createVNode(_component_no_data_img),
              _cache[9] || (_cache[9] = _createElementVNode("h5", { class: "text-align-center" }, [
                _createElementVNode("span", null, "This Supplier catalogue has no stock-items yet. "),
                _createElementVNode("span", { class: "highlight underline" }, "Add some")
              ], -1))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("section", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedStockItems, (catStockItem) => {
            return (_openBlock(), _createBlock(_component_supplier_catalogue_stock_item_card, {
              editing: _ctx.editingStockItems.has(catStockItem.sys.id),
              removing: _ctx.removalQueue.includes(catStockItem.sys.id),
              "onUpdate:editing": ($event: any) => ($event ? _ctx.editingStockItems.add(catStockItem.sys.id) : _ctx.editingStockItems.delete(catStockItem.sys.id)),
              onCancel: ($event: any) => (_ctx.cancelStockItem(catStockItem.sys.id)),
              "cat-stock-item": catStockItem,
              "onUpdate:catStockItem": _ctx.updateCatStockItem,
              "stock-items": _ctx.stockItems,
              catalogue: _ctx.supplierCatalogue,
              request: _ctx.requestHandler,
              "onUpdate:productStore": _ctx.updateProductStore,
              onExpand: (e) => _ctx.expandItem(catStockItem, e),
              onLinkStockItem: _ctx.linkStockItem,
              onRemove: ($event: any) => (_ctx.removeStockItem(catStockItem)),
              highlight: _ctx.updatedItemsByUUID.includes(catStockItem.sys.id)
            }, {
              "product-information": _withCtx(() => [
                (_openBlock(), _createBlock(_component_tab_nav, {
                  active: _ctx.tabState[catStockItem.sys.id],
                  "onUpdate:active": ($event: any) => ((_ctx.tabState[catStockItem.sys.id]) = $event),
                  views: _ctx.tabs,
                  key: _ctx.tabState[catStockItem.sys.id]?.id
                }, {
                  details: _withCtx(({index, view, active}) => [
                    (_ctx.checkDeliveryThreshold(catStockItem))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                          _cache[10] || (_cache[10] = _createElementVNode("b", { class: "warn dark" }, "Available", -1)),
                          _cache[11] || (_cache[11] = _createElementVNode("b", null, "Deliverable until", -1)),
                          _createElementVNode("span", null, _toDisplayString(_ctx.format.date(catStockItem.deliverable_to, _ctx.dateFormat)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (catStockItem.sys.id)
                      ? (_openBlock(), _createBlock(_component_simple_link, {
                          key: 1,
                          id: catStockItem.sys.id,
                          displayField: "dimensions",
                          store: _ctx.products,
                          onResolve: _ctx.updateProductStore
                        }, {
                          default: _withCtx(({resolved, value}) => [
                            value
                              ? (_openBlock(), _createElementBlock("dl", _hoisted_2, [
                                  _cache[12] || (_cache[12] = _createElementVNode("dt", null, "Width", -1)),
                                  _createElementVNode("dd", null, _toDisplayString(value?.width ?? '-'), 1),
                                  _cache[13] || (_cache[13] = _createElementVNode("dt", null, "Height", -1)),
                                  _createElementVNode("dd", null, _toDisplayString(value?.height ?? '-'), 1),
                                  _cache[14] || (_cache[14] = _createElementVNode("dt", null, "Dept", -1)),
                                  _createElementVNode("dd", null, _toDisplayString(value?.depth ?? '-'), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["id", "store", "onResolve"]))
                      : _createCommentVNode("", true),
                    (catStockItem.supplier_product_id)
                      ? (_openBlock(), _createElementBlock("dl", _hoisted_3, [
                          _cache[15] || (_cache[15] = _createElementVNode("dd", { class: "bold highlight" }, "Supplier product ID", -1)),
                          _createElementVNode("dt", _hoisted_4, _toDisplayString(catStockItem.supplier_product_id), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (catStockItem.id)
                      ? (_openBlock(), _createBlock(_component_simple_link, {
                          key: 3,
                          id: catStockItem.id,
                          displayField: "meta",
                          store: _ctx.products,
                          onResolve: _ctx.updateProductStore,
                          "empty-text": " "
                        }, {
                          default: _withCtx(({resolved, value}) => [
                            value
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(value, (metaValue, key) => {
                                  return (_openBlock(), _createElementBlock("dl", _hoisted_5, [
                                    _createElementVNode("dt", null, _toDisplayString(_ctx.format.title(key.toString())), 1),
                                    _createElementVNode("dd", null, _toDisplayString(metaValue), 1)
                                  ]))
                                }), 256))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["id", "store", "onResolve"]))
                      : _createCommentVNode("", true),
                    (catStockItem?.meta)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(catStockItem.meta, (metaValue, key) => {
                          return (_openBlock(), _createElementBlock("dl", _hoisted_6, [
                            _createElementVNode("dt", null, _toDisplayString(_ctx.format.title(key)), 1),
                            _createElementVNode("dd", null, _toDisplayString(metaValue), 1)
                          ]))
                        }), 256))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_7, [
                      (catStockItem.id)
                        ? (_openBlock(), _createBlock(_component_simple_link, {
                            key: 0,
                            id: catStockItem.id,
                            displayField: "description",
                            store: _ctx.products,
                            onResolve: _ctx.updateProductStore
                          }, {
                            default: _withCtx(({resolved, value}) => [
                              _cache[16] || (_cache[16] = _createElementVNode("h6", { class: "bold" }, "Description", -1)),
                              _createElementVNode("p", _hoisted_8, _toDisplayString(value), 1)
                            ]),
                            _: 2
                          }, 1032, ["id", "store", "onResolve"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  prices: _withCtx(({index, view, active}) => [
                    (catStockItem?.price_list)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_9, [
                          _cache[17] || (_cache[17] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", { style: {"width":"100px"} }, "Label"),
                              _createElementVNode("th", null, "Quantity"),
                              _createElementVNode("th", null, "Price")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(catStockItem.price_list, (price, index) => {
                              return (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                                _createElementVNode("td", _hoisted_11, [
                                  _createVNode(_component_form_input, {
                                    class: "mini",
                                    modelValue: catStockItem.price_list[index].label,
                                    "onUpdate:modelValue": ($event: any) => ((catStockItem.price_list[index].label) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("td", _hoisted_12, [
                                  _createVNode(_component_form_input, {
                                    class: "mini",
                                    modelValue: catStockItem.price_list[index].quantity,
                                    "onUpdate:modelValue": ($event: any) => ((catStockItem.price_list[index].quantity) = $event),
                                    type: "number"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createElementVNode("td", _hoisted_13, [
                                  _createVNode(_component_form_input, {
                                    class: "mini",
                                    modelValue: catStockItem.price_list[index].value,
                                    "onUpdate:modelValue": ($event: any) => ((catStockItem.price_list[index].value) = $event),
                                    type: "currency",
                                    "data-currency": "€"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ])
                              ]))
                            }), 256))
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_14, _cache[18] || (_cache[18] = [
                          _createElementVNode("span", null, "This item has no prices set", -1)
                        ]))),
                    _createVNode(_component_ozn_button, {
                      class: "minimal flat",
                      onClick: ($event: any) => (_ctx.addItemPrice(catStockItem))
                    }, {
                      default: _withCtx(() => _cache[19] || (_cache[19] = [
                        _createTextVNode("+ Price")
                      ])),
                      _: 2
                    }, 1032, ["onClick"]),
                    (catStockItem.sys?.editing)
                      ? (_openBlock(), _createBlock(_component_ozn_button, {
                          key: 2,
                          class: "minimal flat",
                          onClick: ($event: any) => (_ctx.updateItemPriceList(catStockItem))
                        }, {
                          default: _withCtx(() => _cache[20] || (_cache[20] = [
                            _createTextVNode("Save changes")
                          ])),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["active", "onUpdate:active", "views"]))
              ]),
              _: 2
            }, 1032, ["editing", "removing", "onUpdate:editing", "onCancel", "cat-stock-item", "onUpdate:catStockItem", "stock-items", "catalogue", "request", "onUpdate:productStore", "onExpand", "onLinkStockItem", "onRemove", "highlight"]))
          }), 256))
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["show-more-stock-items", {expanded: _ctx.expanded}])
        }, [
          (_ctx.expandable && !_ctx.expanded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "col" }, null, -1)),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", {
                    class: "title-container",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleExpand && _ctx.toggleExpand(...args)))
                  }, _cache[21] || (_cache[21] = [
                    _createElementVNode("div", { class: "t-icon space-h1" }, "d", -1),
                    _createElementVNode("div", { class: "title" }, "Show more stock items", -1)
                  ]))
                ]),
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "col" }, null, -1))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  (_ctx.expandable)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "title-container q-mr-auto",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleExpand && _ctx.toggleExpand(...args)))
                      }, _cache[24] || (_cache[24] = [
                        _createElementVNode("div", { class: "t-icon space-h1" }, "c", -1),
                        _createElementVNode("div", { class: "title" }, "Show less stock items", -1)
                      ])))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_q_pagination, {
                      "model-value": _ctx.page,
                      "onUpdate:modelValue": _ctx.setPage,
                      max: _ctx.maxPage,
                      "direction-links": "",
                      flat: "",
                      unelevated: ""
                    }, null, 8, ["model-value", "onUpdate:modelValue", "max"])
                  ])
                ]),
                _cache[25] || (_cache[25] = _createElementVNode("div", { class: "col" }, null, -1))
              ])),
          _cache[26] || (_cache[26] = _createElementVNode("div", { class: "divider" }, null, -1))
        ], 2)
      ]),
      _: 1
    }, 8, ["editing", "expanded", "height", "onAdd", "onCancel", "onSave", "filter-values", "search-value", "filter-value", "onUpdate:searchValue", "onUpdate:filterValue"]),
    _createVNode(_component_entry_search, {
      show: _ctx.search.show,
      "content-type": _ctx.linkType,
      payload: _ctx.filteredStockItems,
      model: _ctx.stockItemModel,
      onSelection: _cache[4] || (_cache[4] = s => { s.selection.forEach(_ctx.select); _ctx.handleSelectionCommit(); _ctx.search.show = false}),
      onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.search.show = false)),
      style: {"min-width":"320px","z-index":"9999"}
    }, null, 8, ["show", "content-type", "payload", "model"])
  ], 64))
}